import {Asn} from "../../../../api/asns/types";

export const allProvidersElement: Asn = {
  id: '',
  organization: 'All providers',
  asn: '',
}